// src/AudioSpectrum/FrequencyAnalyzer.js

import { useRef, useEffect, useCallback } from 'react';

const FrequencyAnalyzer = ({ analyserNode, isPlaying, onDataUpdate }) => {
  const animationRef = useRef();
  const lastUpdateTime = useRef(0);
  
  const analyzeFrequency = useCallback(() => {
    if (!analyserNode || !isPlaying) return;
    
    const now = performance.now();
    
    // 60fps로 제한 (약 16.67ms마다 업데이트)
    if (now - lastUpdateTime.current < 16.67) {
      animationRef.current = requestAnimationFrame(analyzeFrequency);
      return;
    }
    
    const bufferLength = analyserNode.frequencyBinCount;
    const frequencyData = new Uint8Array(bufferLength);
    const timeDomainData = new Uint8Array(bufferLength);
    
    // 주파수 도메인 데이터 (스펙트럼)
    analyserNode.getByteFrequencyData(frequencyData);
    // 시간 도메인 데이터 (파형)
    analyserNode.getByteTimeDomainData(timeDomainData);
    
    onDataUpdate({
      frequency: frequencyData,
      timeDomain: timeDomainData,
      sampleRate: analyserNode.context.sampleRate,
      fftSize: analyserNode.fftSize,
      bufferLength: bufferLength
    });
    
    lastUpdateTime.current = now;
    animationRef.current = requestAnimationFrame(analyzeFrequency);
  }, [analyserNode, isPlaying, onDataUpdate]);
  
  useEffect(() => {
    if (isPlaying && analyserNode) {
      analyzeFrequency();
    } else {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    }
    
    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [isPlaying, analyserNode, analyzeFrequency]);
  
  return null; // 이 컴포넌트는 렌더링하지 않음
};

export default FrequencyAnalyzer;